import React, { useState } from 'react';
import type { SequenceEnrollment } from '../../types/sequence';
import EnrollSequenceModal from './EnrollSequenceModal';

interface Props {
  contact: { type: 'client' | 'lead'; id: string; name: string };
  onEnrolled?: (enrollment: SequenceEnrollment) => void;
  className?: string;
  label?: string;
}

/** Reusable "Start sequence" trigger for contact headers and row actions. */
const StartSequenceButton: React.FC<Props> = ({ contact, onEnrolled, className, label = 'Start sequence' }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={className ?? 'btn-secondary rounded-xl px-4 py-2 text-sm'}
      >
        {label}
      </button>
      {open ? (
        <EnrollSequenceModal
          contact={contact}
          onClose={() => setOpen(false)}
          onEnrolled={(e) => {
            setOpen(false);
            onEnrolled?.(e);
          }}
        />
      ) : null}
    </>
  );
};

export default StartSequenceButton;
